import type { App } from 'vue';
import { markRaw, readonly } from 'vue';

import { PLUGIN_KEY } from './providers';
import { createState } from './state';
import type { PluginOptions, RequestPlugin } from './types';

export const state = createState();

export function createRequest(options: PluginOptions): RequestPlugin {
  return markRaw({
    config: readonly(options),

    state: readonly(state),

    onError: (clb) => {
      state.onErrorClb = clb;
    },

    install(app: App): void {
      app.provide(PLUGIN_KEY, this);
      app.config.globalProperties['$request'] = this;
    },
  });
}
